import { render } from "./UserInvitationDialog.vue?vue&type=template&id=0b080e10"
import script from "./UserInvitationDialog.vue?vue&type=script&lang=js"
export * from "./UserInvitationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__